import { Col, Form, FormInstance, Input, InputNumber, Row, Switch } from "antd";
import { useState } from "react";
import { EditEventFormType } from "../CreateOrEditEvent";
import CompanyCard from "./CompanyCard";

interface Props {
  form: FormInstance<EditEventFormType>;
}

const CompanyCardWaitlist: React.FC<Props> = ({ form }) => {
  const [waitingList, setWaitingList] = useState(form.getFieldValue("use_waiting_list"));
  const [externalBooking, setExternalBooking] = useState(form.getFieldValue("is_external_booking"));

  const onChange = (checked: boolean) => {
    setWaitingList(checked);
    form.setFieldValue("use_waiting_list", checked);

    if (!checked) {
      form.setFieldValue("waiting_list_size", 0);
    } else {
      form.setFieldValue("waiting_list_size", 15);
    }
  };

  const onChangeExternalBooking = (checked: boolean) => {
    setExternalBooking(checked);
    form.setFieldValue("is_external_booking", checked);
    if (!checked) {
      form.setFieldValue("external_booking_url", "");
    }
  };

  const onChangeSize = (value: number | null) => {
    form.setFieldValue("waiting_list_size", value);
  };
  const onChangeOverbooking = (value: number | null) => {
    form.setFieldValue("overbooking", value);
  };

  return (
    <CompanyCard title="Venteliste og overbooking">
      <Row>
        <Form.Item<EditEventFormType> name="use_waiting_list" label="Benytt venteliste" valuePropName="checked">
          <Switch checkedChildren="Ja" unCheckedChildren="Nei" onChange={onChange} style={{ width: "50px" }} />
        </Form.Item>
      </Row>
      <Row gutter={[30, 30]}>
        <Col md={12} xs={24}>
          <Form.Item<EditEventFormType>
            name="waiting_list_size"
            label="Antall ventelisteplasser"
            rules={[{ required: true, message: "Skriv inn antall ventelisteplasser" }]}
          >
            <InputNumber
              size="large"
              min={0}
              onChange={onChangeSize}
              style={{ width: "98%" }}
              disabled={!waitingList}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item<EditEventFormType>
            name="overbooking"
            label="Overbooking"
            rules={[{ required: true, message: "Angi ønsket overbooking" }]}
          >
            <InputNumber size="large" min={0} onChange={onChangeOverbooking} addonAfter="%" style={{ width: "98%" }} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Form.Item<EditEventFormType>
          name="is_external_booking"
          label="Søknadsbasert (eksternt påmeldingssystem)"
          valuePropName="checked"
        >
          <Switch
            checkedChildren="Ja"
            unCheckedChildren="Nei"
            onChange={onChangeExternalBooking}
            style={{ width: "50px" }}
          />
        </Form.Item>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item<EditEventFormType>
            name="external_booking_url"
            label="Link til eksternt påmeldingsskjema"
            rules={[
              { required: externalBooking, message: "Oppgi en link til påmeldingsskjemaet" },
              { type: "url", message: "Oppgi en gyldig url" },
              { max: 500, message: "Link kan ikke være lengre enn 500 tegn" },
            ]}
          >
            <Input
              placeholder="Link til eksternt påmeldingsskjema"
              maxLength={500}
              showCount
              disabled={!externalBooking}
            />
          </Form.Item>
        </Col>
      </Row>
    </CompanyCard>
  );
};

export default CompanyCardWaitlist;
